/* eslint-disable @typescript-eslint/unbound-method */
// import { app } from '../app';

// @ts-nocheck
// eslint-disable-next-line no-extend-native
String.prototype.ls = function ls(values?: { [key: string]: string }) {
  return this;
  // let str = app.translator.translate(this.toString());
  // if (values) {
  //   Object.entries(values).forEach(([key, value]) => {
  //     const reg = new RegExp(`\\$\\[${key}\\n]`, 'g');
  //     str = str.replace(reg, value);
  //   });
  // }
  // return str;
};
